import $ from 'jquery';
import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";

function initApp() {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    homeFunc();
}

// load 後にバンドルが実行されると $(window).on('load') は一度も走らないことがある
if (document.readyState === 'complete') {
    initApp();
} else {
    $(window).on('load', initApp);
}